export const frontmatter = {
  title: "Launch Details",
  order: 1,
}

## What To Expect

This expansion is a strategic move that aims to generate new revenue opportunities for Scale.farm.

Our key goal is to build a sustainable future leveraging the power of L2 technology, expanding upon our current success and community.

## Why BASE

The decision to expand to BASE Chain is strategic. BASE Chain offers opportunities that we believe are beneficial for our users and platform. Here's why we're excited:

- BASE is a Layer 2 solution that has gained significant attention from the crypto community. Its ambitious goal of becoming the leading Layer 2, backed by Coinbase, provides a foundation of stability for our expansion.

- We see the potential for BASE to become the industry's leading Layer 2 solution. We believe being part of this journey will provide immense opportunities for our users.

- Utilizing the OP Technology Stack, Base Chain presents a unique advantage for our expansion. This technology stack has proven efficient and reliable, which aligns with our commitment to offer our community the best experiences in DeFi.

## The Launch Liquidity Sequence

Our launch on Base Chain will be executed in a phased manner to ensure stability and safety. Here's how the liquidity sequence will unfold:

1. Initial Liquidity Pool Setup: We'll set up the initial liquidity pool with a combination of SCALE and ETH. This will serve as the primary source for purchasing SCALE.
2. SCALE Swap Fees: We will set up our liquidity pool with a time-reducing fee structure. Trade fees on the SCALE/ETH pair will start at 99% and gradually decrease to 2% over the first 60 minutes of launch.
3. Expansion of Pairs: As the ecosystem grows, we'll introduce more trading pairs based on market dynamics.
